import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const QUERY_MANAGEMENT_ENDPOINT = '/api/v1/complaints';

const rejectRequest = (error, thunkApi) =>
  thunkApi.rejectWithValue({
    status: error?.response?.status ?? error?.status,
    message:
      error?.response?.data?.message ??
      error?.response?.data?.error ??
      error?.message ??
      'Something went wrong',
  });

export const fetchQueries = createAsyncThunk(
  'queryManagement/fetchQueries',
  async (params, thunkApi) => {
    try {
      const { complaintTypeId, page = 1, limit = 10 } = params || {};
      const response = await api.get(QUERY_MANAGEMENT_ENDPOINT, {
        params: {
          page,
          limit,
          complaintTypeId,
        },
        signal: thunkApi.signal,
      });
      return response.data;
    } catch (error) {
      return rejectRequest(error, thunkApi);
    }
  },
);
